
import { mapState } from 'vuex'
import dayjs from 'dayjs'
import Loading from '@/components/detail/Loading.vue'
import emojipick from '@/components/comments/emojipick.vue'
import { bus } from '~/assets/js/eventBus'
let optime = 0

export default {
  name: 'ImgTextCommon',
  components: {
    Loading,
    emojipick
  },
  props: {
    placeholder: {
      type: String,
      default: ''
    },
    txt: {
      type: String,
      default: ''
    },
    maxwords: {
      type: Number,
      default: 1500
    },
    maximgs: {
      type: Number,
      default: 9
    }
  },
  data() {
    return {
      descContent: this.txt || '', // 内容
      fileList: [],
      imglist: [],
      showDrag: false, // 极验开关
      product: 'bind', // 极验展示效果
      sel: '',
      selectContents: '',
      range: '',
      taget: '', // 光标所在的标签
      options: {
        closeable: true,
        size: '72px'
      }
    }
  },
  computed: {
    ...mapState({
      contentcookie: 'contentcookie'
    }),
    // 用户是否登录
    isLogin() {
      return this.$store.state?.user?.userId || ''
    }
  },
  watch: {
    imglist(newV) {
      // 监听图片的变化
      let _content = this.descContent
      if (newV == this.placeholder) {
        _content = ''
      }
      this.$emit('changeimgcontent', { content: _content, imglist: newV })
    },
    descContent(newVal) {
      if (newVal && newVal.length > this.maxwords) {
        // 如果超出最大字数，截取字数并提示用户
        this.$Toast({
          message: this.$v('最多可输入{0}个字符').replace('{0}', this.maxwords),
          position: 'middle'
        })
      }
      this.$emit('changeimgcontent', {
        content: this.descContent,
        imglist: this.imglist
      })
    }
  },
  mounted() {
    const that = this
    bus.$off('getemoji')
    bus.$on('getemoji', (emoji) => {
      const _time = dayjs().valueOf()
      if (!optime || _time - optime > 800) {
        optime = _time
        that.insertEmoji(emoji)
      } else {
        console.log('getemoji-重复的', _time)
      }
    })
    // console.log('发图文')
  },
  beforeDestroy() {
    bus.$off('getemoji')
  },
  methods: {
    // 表情包点击事件
    insertEmoji(emoji) {
      // 作用的文本框id
      const textarea = document.getElementById('fxtextcontent')

      const originalValue = textarea.value
      const selectionStart = textarea.selectionStart
      const selectionEnd = textarea.selectionEnd
      const before = originalValue.substring(0, selectionStart)
      const after = originalValue.substring(selectionEnd)
      const newValue = before + emoji + after
      textarea.value = newValue
      textarea.selectionStart = selectionStart + emoji.length
      textarea.selectionEnd = selectionStart + emoji.length
      this.descContent = newValue
    },
    popemoji() {
      this.$refs.emoji.PopEmoji()
    },
    afterRead(file) {
      // 上传图片
      if (!this.focusFn()) {
        return false // 用户未登录
      }
      let arr = []
      if (file instanceof Array) {
        arr = [...file]
      } else {
        arr = [file]
      }
      const imgcount = this.fileList?.length
      for (let i = 0; i < arr.length; i++) {
        const _ext = arr[i].file.type.split('/')[1]
        const _ext2 = arr[i].file?.name?.split('.')?.slice(-1)[0] || ''
        if (_ext && _ext2 && (!['jpg', 'jpeg', 'png'].includes(_ext.toLowerCase()) || !['jpg', 'jpeg', 'png'].includes(_ext2.toLowerCase()))) {
          this.$Toast({
            message: '请上传正确格式的图片(.jpg或.png)',
            position: 'middle'
          })
          this.fileList.splice(i + imgcount - arr.length > 0 ? i + imgcount - arr.length : 0, 1)
          return false
        } else {
          this.$refs.Popoverload.open()
          this.$api.common
            .CV3(
              {
                uid: this.$store.state.user.userId,
                base64: arr[i].content?.split(',')[1], // base64格式
                ext: _ext,
                languageCode: this.$store.state.LanguageCode
              },
              {
                Routes: 'wikifxfabulous$fileimage'
              }
            )
            .then((res) => {
              this.$refs.Popoverload.close()
              if (!res || res.wikifxfabulous.fileimage.succeed == false) {
                arr[i].status = 'failed'
                arr[i].message = '上传失败'
                return this.$Toast({
                  message: '上传失败',
                  position: 'middle'
                })
              }

              if (res && res.wikifxfabulous && res.wikifxfabulous.fileimage && res.wikifxfabulous.fileimage.data) {
                const domain = res.wikifxfabulous.fileimage.data.domain
                const path = res.wikifxfabulous.fileimage.data.url
                this.imglist.push(domain + path)
              }
            })
            .catch((err) => {
              console.log(err, 'servicepublish')
              this.$refs.Popoverload.close()
              arr[i].status = 'failed'
              arr[i].message = '上传失败'
              this.$Toast({
                message: '上传失败',
                position: 'middle'
              })
            })
        }
      }
    },
    async beforeRead(file) {
      let number = 1
      if (file?.length > 1) number = file?.length
      const num = this.fileList?.length + number // 总数
      if (num > 9) {
        this.$toast(this.$v('最多上传{0}张').replace('{0}', 9))
        return false
      } else if (number == 1) {
        if (file.type !== 'image/jpeg' && file.type !== 'image/png') {
          this.$toast(this.$v('图片格式错误，请重新选择'))
          return false
        } else {
          const ext = file?.name?.split('.')?.slice(-1)[0] || ''
          if (ext && !['jpg', 'jpeg', 'png'].includes(ext.toLowerCase())) {
            this.$toast(this.$v('图片格式错误，请重新选择') + '...')
            return false
          }
        }

        if (file.size >= 20971520) {
          return this.$toast(this.$t('38989').replace('{0}', '20MB'))
        }
      } else {
        for (let i = 0; i < file.length; i++) {
          if (file[i].type !== 'image/jpeg' && file[i].type !== 'image/png') {
            this.$toast(this.$v('图片格式错误，请重新选择'))
            return false
          } else {
            const ext = file[i]?.name?.split('.')?.slice(-1)[0] || ''
            if (ext && !['jpg', 'jpeg', 'png'].includes(ext.toLowerCase())) {
              this.$toast(this.$v('图片格式错误，请重新选择') + '...')
              return false
            }
          }
        }
        for (let i = 0; i < file.length; i++) {
          if (file[i].size >= 20971520) {
            this.$toast(this.$t('38989').replace('{0}', '20MB'))
            return false
          }
        }
      }

      if (number == 1) {
        if (file.size >= 10485760) {
          const imgFile = await this.compressImage(file)
          return imgFile
        } else {
          return file
        }
      } else {
        const fileList = await Promise.all(file.map((el) => this.compressImage(el)))
        return fileList
      }
    },
    beforedelete(file, detail) {
      const index = detail.index
      this.fileList.splice(index, 1)
      this.imglist.splice(index, 1)
    },
    compressImage(file) {
      // 压缩图片
      if (file.size >= 10485760) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader()
          console.log(123)
          reader.onload = function (event) {
            const img = new Image()
            img.src = event.target.result
            img.onload = function () {
              const canvas = document.createElement('canvas')
              const ctx = canvas.getContext('2d')
              const maxWidth = 800 // 设置最大宽度
              const maxHeight = 800 // 设置最大高度
              let targetWidth = img.width
              let targetHeight = img.height

              if (targetWidth > maxWidth || targetHeight > maxHeight) {
                if (targetWidth / targetHeight > maxWidth / maxHeight) {
                  targetWidth = maxWidth
                  targetHeight = Math.round(maxWidth * (img.height / img.width))
                } else {
                  targetHeight = maxHeight
                  targetWidth = Math.round(maxHeight * (img.width / img.height))
                }
              }

              canvas.width = targetWidth
              canvas.height = targetHeight

              ctx.clearRect(0, 0, targetWidth, targetHeight)
              ctx.drawImage(img, 0, 0, targetWidth, targetHeight)

              // 将压缩后的图片数据和文件名添加到 Blob 对象中
              canvas.toBlob(
                function (blob) {
                  const compressedImage = new Blob([blob], {
                    type: 'image/jpeg'
                  })
                  compressedImage.name = file.name
                  resolve(compressedImage)
                },
                'image/jpeg',
                0.8 // 设置压缩质量
              )
            }
          }
          reader.readAsDataURL(file)
        })
      } else {
        return file
      }
    },
    // 检测登录
    popimgpick() {
      if (!this.focusFn()) {
        return false // 用户未登录
      } else if (this.imglist?.length >= 9) {
        return this.$message({
          message: this.$v('最多上传{0}张').replace('{0}', 9),
          type: 'error',
          duration: 1500
        })
      } else {
        this.$refs.imgupload.chooseFile()
      }
    },
    // 输入框获得焦点事件
    focusFn() {
      if (this.isLogin) return true // 用户已登录，不执行任何操作
      this.$store.commit('loginClose', true)
      return false
    },
    // 判断是否包含html标签
    containsHTMLTag(str) {
      return /<[^>]*>/g.test(str)
    }
  }
}
